import { Component, Input, OnInit } from '@angular/core';
import { FileUtils } from 'src/app/data/utils/file.utils';

@Component({
  selector: 'app-chat-file',
  templateUrl: './chat-file.component.html',
  styleUrls: ['./chat-file.component.scss'],
})
export class ChatFileComponent implements OnInit {
  fileType: string | undefined;
  @Input() fileName!: string;

  pdfIcon: string | undefined = '../../../../assets/icons/pdf-img.png';
  imageIcon: string | undefined = '../../../../assets/icons/image-img.png';

  constructor(private readonly fileUtils: FileUtils) {}

  ngOnInit() {
    this.getFiles();
  }

  getFiles() {
    if (this.fileUtils.fileExtension(this.fileName) === 'PDF') {
      this.fileType = this.pdfIcon;
    } else if (this.fileUtils.isImage(this.fileName)) {
      this.fileType = this.imageIcon;
    }
  }

  fileExtension(name: string) {
    return this.fileUtils.fileExtension(name);
  }
}
